/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Color_PrimaryInputs */



/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Presentation_Template_Color_PrimaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_color_primary = /** @type {((inputs?: Presentation_Template_Color_PrimaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Color_PrimaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Primär")
	return /** @type {LocalizedString} */ ("Primary")
});